export default __webpack_public_path__ + "static/media/kentucky.00b8caad.jpg";